export const getSlideProjectName = () => {
  return {
    hidden: {
      opacity: 1,
      transition: { duration: 0.3 },
    },
    visible: {
      opacity: 0.6,
      transition: { duration: 0.3 },
    },
  };
};
